"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _decoration = require("@/api/decoration");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'DecorationCampaign',
  data: function data() {
    return {
      loading: false,
      searchForm: {
        page: 1,
        limit: this.$constants.page.limit[0],
        keywords: ''
      },
      tableData: {
        data: [],
        total: 0
      }
    };
  },
  created: function created() {
    this.loadCurrent();
  },
  methods: {
    actionText: function actionText(value) {
      return {
        submit: '提交',
        activate: '投放',
        pause: '暂停',
        resume: '恢复',
        complete: '结束',
        cancel: '取消',
        register: '报名',
        confirm: '确认',
        attend: '到场',
        convert: '转化'
      }[value] || value;
    },
    loadCurrent: function loadCurrent() {
      var _this = this;
      this.loading = true;
      (0, _decoration.decorationCampaignListApi)(this.searchForm).then(function (data) {
        _this.tableData.data = data.list || [];
        _this.tableData.total = data.total || 0;
      }).finally(function () {
        _this.loading = false;
      });
    },
    handleSearch: function handleSearch() {
      this.searchForm.page = 1;
      this.loadCurrent();
    },
    openCreate: function openCreate() {
      var _this2 = this;
      var start = new Date();
      var end = new Date(Date.now() + 7 * 86400000);
      var fmt = function fmt(d) {
        return "".concat(d.getFullYear(), "-").concat(String(d.getMonth() + 1).padStart(2, '0'), "-").concat(String(d.getDate()).padStart(2, '0'), " ").concat(String(d.getHours()).padStart(2, '0'), ":").concat(String(d.getMinutes()).padStart(2, '0'), ":00");
      };
      this.$prompt('活动名称', '新活动').then(function (_ref) {
        var value = _ref.value;
        (0, _decoration.decorationCampaignSaveApi)({
          name: value || '周末爆破',
          campaignType: 'blast',
          groupKey: '翠湖苑',
          budget: 0,
          startTime: fmt(start),
          endTime: fmt(end)
        }).then(function () {
          _this2.$message.success('活动已创建');
          _this2.loadCurrent();
        });
      }).catch(function () {});
    },
    runAction: function runAction(row, action) {
      var _this3 = this;
      this.$confirm("\u786E\u8BA4".concat(this.actionText(action), "\uFF1F")).then(function () {
        (0, _decoration.decorationCampaignActionApi)(row.campaign.id, {
          action: action
        }).then(function () {
          _this3.$message.success('活动已更新');
          _this3.loadCurrent();
        });
      }).catch(function () {});
    }
  }
};